import paths, { legacyPathRedirects } from './paths'

export const legacyParamRedirects = [
  { from: '/vendor/:id', buildTarget: (id) => `/vendors/${id}/edit` },
  { from: '/invoice/:invoiceId', buildTarget: (id) => `/invoices/${id}` },
  { from: '/warehouse/:id', buildTarget: (id) => `/warehouses/${id}/edit` },
  { from: '/expenses_categories/:id', buildTarget: (id) => `/expense-categories/${id}/edit` },
  { from: '/profiles/:id', buildTarget: (id) => `/users/${id}/edit` },
]

export const legacyStaticRedirects = [...legacyPathRedirects, { from: '/profiles/', to: paths.users.new }]
